import { connect } from "react-redux";
import ProfilePage from "./ProfilePage"
import { fetchUserProfile } from "../../../../redux/actions/management_actions"
import { fetchAllWorkInstructions} from "../../../../redux/actions/wi_actions"
const mapStateToProps = (state) => {
    return ({
        user: state.management.user,
        sessionUser: state.session.user,
        // workInstructions: state.work_instructions.all
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        fetchUserProfile: (userId, cancelToken) => dispatch(fetchUserProfile(userId, cancelToken)),
        // fetchAllWorkInstructions: (cancelToken) => dispatch(fetchAllWorkInstructions(cancelToken))
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);
